import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BookmarkIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.99857 12.1079L4.22496 15.1957C3.73496 15.5967 2.99928 15.2476 3 14.6144L3.012 4.11212C3.01373 2.59456 4.24444 1.36526 5.762 1.36526H10.2471C11.7659 1.36526 12.9971 2.59648 12.9971 4.11526V14.6153C12.9971 15.248 12.2619 15.5964 11.7722 15.1957L7.99857 12.1079Z"
		/>
	</svg>
))
